//@flow
import React from 'react';
import type { VersionType } from 'types/product';
import './styles.scss';
import { FloorPlanMobile } from 'components/molecules/floorPlanMobile';

type Props = {
  data: Array<VersionType>,
};
export const VariationsOverlay = (props: Props) => {
  const { data } = props;
  return (
    <div className={'versions-overlay'}>
      <FloorPlanMobile versions={data} mode={'overlay'} />
    </div>
  );
};
